// Data residency (Milestone B, Phase B3): where an organization's data lives.
// One Firebase project per region; chosen at creation and permanent. The
// server validates the choice against its own live list (RESIDENCY_REGIONS);
// environment.residencyRegions only decides what the picker offers.

export type ResidencyRegion = 'ca' | 'us' | 'eu';

/** Display order; Canada first and the default. */
export const RESIDENCY_REGIONS: readonly ResidencyRegion[] = ['ca', 'us', 'eu'];

export const DEFAULT_RESIDENCY_REGION: ResidencyRegion = 'ca';

export function isResidencyRegion(value: unknown): value is ResidencyRegion {
  return value === 'ca' || value === 'us' || value === 'eu';
}

/** Live regions from config, in display order, always including Canada. */
export function liveResidencyRegions(configured: readonly string[] | undefined): ResidencyRegion[] {
  const wanted = new Set<string>([DEFAULT_RESIDENCY_REGION, ...(configured ?? [])]);
  return RESIDENCY_REGIONS.filter((r) => wanted.has(r));
}
